import styled from '@mui/material/styles/styled';

export const Root = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
});

export const LeftPanel = styled('div')(({ theme }) => ({
  flexShrink: 0,
  height: '100%',
  width: theme.app.tool.leftPanelWidth,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  borderRight: `1px solid ${theme.palette.border}`,
  overflow: 'auto',
  padding: '16px 8px',
}));

export const NavList = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px'
}));

export const Content = styled('div')({
  flexGrow: 1,
  overflow: 'auto',
});